import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[uppercase]',
  standalone: true // Use if you are using standalone components
})
export class UppercaseDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;

    this.el.nativeElement.value = initialValue.toUpperCase();
    
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}